/***
 * 
 * 
 * 
 * 
 * 















 */
import * as StringUtil from "@/common/utils/StringUtil";

export const DATETIME_DEFAULT = "yyyy-MM-dd HH:mi:ss";

/**
 *
 * @param format 날짜/시간 포맷 (함수 참고)
 * @returns 포맷에 맞는 날짜/시간 데이터
 */
export function getDatetime(date: Date, format: string = DATETIME_DEFAULT) {
  const weekKorName = [
    "일요일",
    "월요일",
    "화요일",
    "수요일",
    "목요일",
    "금요일",
    "토요일",
  ];
  const weekKorShortName = ["일", "월", "화", "수", "목", "금", "토"];
  const weekEngName = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const weekEngShortName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const year = String(date.getFullYear()).slice(-2); // 년도의 마지막 두 자리
  const month2 = String(date.getMonth() + 1).padStart(2, "0"); // 월 2자리
  const month1 = String(date.getMonth() + 1); // 월 2자리
  const day2 = String(date.getDate()).padStart(2, "0"); // 일 2wkfl
  const day1 = String(date.getDate()); // 일
  const hours24 = String(date.getHours()).padStart(2, "0"); // 시 24시간 2자리
  const hours241 = String(date.getHours()).padStart(2, "0"); // 시 24시간 1자리
  const hours12 = String(date.getHours() % 12).padStart(2, "0"); // 시 12시간 2자리
  const hours121 = String(date.getHours() % 12).padStart(1, "0"); // 시 12시간 1자리
  const minutes2 = String(date.getMinutes()).padStart(2, "0"); // 분
  const minutes1 = String(date.getMinutes()).padStart(1, "0"); // 분
  const seconds = String(date.getSeconds()).padStart(2, "0"); // 초
  const seconds1 = String(date.getSeconds()).padStart(1, "0"); // 초
  const ap = String(date.getHours() < 12 ? "오전" : "오후"); // 초
  const weeKoreaLong = weekKorName[date.getDay()];
  const weeKoreaShort = weekKorShortName[date.getDay()];
  const weeEnglishLong = weekEngName[date.getDay()];
  const weeEnglishShort = weekEngShortName[date.getDay()];

  // 입력된 형식에 따라 날짜 및 시간을 반환
  const result = format
    .replace("yyyy", date.getFullYear().toString())
    .replace("yy", year)
    .replace("MM", month2)
    .replace("MO", month1)
    .replace("dd", day2)
    .replace("do", day1)
    .replace("HH", hours24)
    .replace("HO", hours241)
    .replace("hh", hours12)
    .replace("ho", hours121)
    .replace("mi", minutes2)
    .replace("mo", minutes1)
    .replace("ss", seconds)
    .replace("so", seconds1)
    .replace("KL", weeKoreaLong)
    .replace("KS", weeKoreaShort)
    .replace("EL", weeEnglishLong)
    .replace("ES", weeEnglishShort)
    .replace("a/p", ap);

  //   console.log("result : ", result);
  return result;
}

export const getToday = (format?: string) => {
  return getDatetime(new Date(), format);
};

/**
 * 특정날짜 가져오기
 * @param {*} date 특정 날짜
 * @param {*} frm  출력 포맷
 * getDate("20000101123456", "yyyy년 MM월 dd일 HH시 mm분 ss초")
 */
export const getDate = (date: any, frm: string = DATETIME_DEFAULT) => {
  if (StringUtil.isEmpty(date)) {
    return "";
  }
  const returnDate = validateDate(date);
  return getDatetime(returnDate, frm);
};

/**
 * 입력받은 데이터가 date 타입인지 아닌지 확인
 * @param {} date
 */
export const validateDate = (date: any) => {
  if (Object.prototype.toString.call(date) !== "[object Date]") {
    date = converStringToDate(date);
  }
  return date;
};

/**
 * 입력받은 String 을 Date로 변경
 * @param {} str : 형식 yyyyMMddHHmmss
 */
export const converStringToDate = (str: string): Date => {
  str = str.replace(/[^0-9]/g, "");
  return new Date(
    parseInt(str.substring(0, 4)) || 0,
    parseInt(str.substring(4, 6)) - 1 || 0,
    parseInt(str.substring(6, 8)) || 0,
    parseInt(str.substring(8, 10)) || 0,
    parseInt(str.substring(10, 12)) || 0,
    parseInt(str.substring(12, 14)) || 0
  );
};

/**
 * 두 Date 밀리세컨즈 차이값 구하기
 * @param date1
 * @param date2
 * @returns milli seconds: number
 */
export const getDifMilli = (date1: any, date2: any): number => {
  date1 = validateDate(date1);
  date2 = validateDate(date2);
  return date1 >= date2 ? date1 - date2 : date2 - date1;
  // return dif / (60 * 60 * 24);
};

/**
 * 두 Date 날짜 차이값 구하기
 * @param date1
 * @param date2
 * @returns date: number
 */
export const getDifDates = (date1: any, date2: any): number => {
  return Math.floor(getDifSeconds(date1, date2) / (60 * 60 * 24));
};

/**
 * 두 Date 초 차이값 구하기
 * @param date1
 * @param date2
 * @returns seconds: number
 */
export const getDifSeconds = (date1: any, date2: any): number => {
  return Math.floor(getDifMilli(date1, date2) / 1000);
};

export const getSeconds = (date: any) => {
  return Math.floor(date / 1000);
};

export const getMinutes = (date: any) => {
  return Math.floor(getSeconds(date) / 60);
};

export const getHours = (date: any) => {
  return Math.floor(getMinutes(date) / 60);
};

export const getDays = (date: any) => {
  return Math.floor(getHours(date) / 24);
};

export const getWeeks = (date: any) => {
  return Math.floor(getDays(date) / 7);
};

export const getYears = (date: any) => {
  return Math.floor(getDays(date) / 365);
};

export const jsonPrettier = (jsonData: any): string => {
  let result = "";
  if (jsonData.time.hour < 10) {
    jsonData.time.hour = "0" + jsonData.time.hour;
  }
  if (jsonData.time.minute < 10) {
    jsonData.time.minute = "0" + jsonData.time.minute;
  }
  if (jsonData.time.second < 10) {
    jsonData.time.second = "0" + jsonData.time.second;
  }

  jsonData.time.nano = jsonData.time.nano.zf(3);
  jsonData.time.nano = jsonData.time.nano.substring(0, 3);

  result += jsonData.date.year + "년 ";
  result += jsonData.date.month + "월 ";
  result += jsonData.date.day + "일 ";

  result += jsonData.time.hour + ":";
  result += jsonData.time.minute + ":";
  result += jsonData.time.second + "+";
  result += jsonData.time.nano;
  return result;
};

export const getThisYearFirstDate = (): string => {
  return getToday("yyyy0101");
};

export const getDateFormatByTimestamp = (timestamp: number, format: string) => {
  const date = new Date(timestamp * 1000);
  const options: Intl.DateTimeFormatOptions = {
    timeZone: "Asia/Seoul",
    year: "numeric", // "string"이 아니라 "numeric"이어야 함
    month: "long", // "short", "long", "2-digit" 가능
    day: "numeric",
  };
  const kstDate = date.toLocaleDateString("ko-KR", options);
  return getDate(kstDate, format);
};
